module.exports = __webpack_public_path__ + "img/exp_1.eb80d8b4.png";